import { render, staticRenderFns } from "./CoreValueEditor.vue?vue&type=template&id=667a49e6&"
import script from "./CoreValueEditor.vue?vue&type=script&lang=js&"
export * from "./CoreValueEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports